import React, { useEffect, useState } from 'react';
import { AppProvider } from '@shopify/polaris';
import { Provider, NavigationMenu } from '@shopify/app-bridge-react';
import createApp from '@shopify/app-bridge';
import { Redirect } from '@shopify/app-bridge/actions';
import LinearProgress from '@material-ui/core/LinearProgress';
import Grid from '@material-ui/core/Grid';
import enTranslations from '@shopify/polaris/locales/en.json';
import '@shopify/polaris/dist/styles.css';
import ToastProvider from './contexts/toast-context';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import routes, { renderRoutes, getNavigationLinks } from './routes';

const urlParams = new URLSearchParams(window.location.search);
let shop = urlParams.get('shop');
const host = urlParams.get('host');

if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') {
  shop = process.env.REACT_APP_DEV_SHOP;
}

const app = createApp({
  apiKey: process.env.REACT_APP_SHOPIFY_API_KEY,
  // shopOrigin: shop,
  host
});

export const redirect = Redirect.create(app);

const history = createBrowserHistory();

export default function App() {
  const [isEmbedded, setIsEmbedded] = useState(true);

  useEffect(() => {
    if (window.location !== window.parent.location) {
      setIsEmbedded(true);
    }
  }, [])

  const config = {
    apiKey: process.env.REACT_APP_SHOPIFY_API_KEY,
    forceRedirect: (process.env.NODE_ENV === 'production') ? true : false,
    host
  };

  if (process.env.NODE_ENV === 'production' && !isEmbedded) {
    return <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justify="center"
      style={{ minHeight: '100vh' }}
    >
      <Provider config={config}>
        <AppProvider i18n={enTranslations}>
          <Grid item xs={3}>
            <LinearProgress style={{ width: 400 }} />
          </Grid>
        </AppProvider>
      </Provider>
    </Grid>
  }

  return (
    <Provider config={config}>
      <AppProvider i18n={enTranslations}>
        <ToastProvider>
          <Router history={history}>
            {renderRoutes(routes)}
          </Router>
          <NavigationMenu navigationLinks={getNavigationLinks()} />
        </ToastProvider>
      </AppProvider>
    </Provider>
  );
}
